import { NavLink, useParams } from 'react-router-dom'
import { useHandleUrl } from '../../hooks/useHandleUrl'
import {
  IconData,
  IconTypes,
  IconArticles,
  IconFactory,
  IconTransport,
  IconMount,
  IconReview,
  IconSummary,
  IconBimLinks,
} from 'lib/icons/Icon'
import { de } from 'date-fns/locale'

const routesInit = [
  {
    label: 'Datos',
    href: '/datos',
    icon: <IconData />,
    value: 'datos',
  },
]

const routes = [
  {
    label: 'BimLinks',
    href: '/bimlink',
    icon: <IconBimLinks style={{ color: 'white' }} />,
    value: 'bimlink',
  },
  {
    label: 'Tipos',
    href: '/tipos',
    icon: <IconTypes style={{ color: 'white' }} />,
    value: 'tipos',
  },
  {
    label: 'Artículos',
    href: '/articulos',
    icon: <IconArticles style={{ color: 'white' }} />,
    value: 'articulos',
  },
]

const routesJitSystem = [
  {
    label: 'Fábrica',
    href: '/fabrica',
    icon: <IconFactory style={{ color: 'white' }} />,
    value: 'fabrica',
  },
  {
    label: 'Transporte',
    href: '/transporte',
    icon: <IconTransport style={{ color: 'white' }} />,
    value: 'transporte',
  },
  {
    label: 'Montaje',
    href: '/montaje',
    icon: <IconMount style={{ color: 'white' }} />,
    value: 'montaje',
  },
  {
    label: 'Repasos',
    href: '/repasos',
    icon: <IconReview style={{ color: 'white' }} />,
    value: 'repasos',
  },
  {
    label: 'Resumen',
    href: '/resumen',
    icon: <IconSummary style={{ color: 'white'}} />,
    value: 'resumen',
  },
]

const Sidebar = () => {
  const { idProject } = useParams()
  const { changeLocation } = useHandleUrl()

  return (
    <nav className="sidebar">
      <div className="sidebar-items">
        {routesInit.map((item, index) => (
          <NavLink
            to={changeLocation(`/viewer/${idProject}${item.href}`)}
            className={({ isActive }) =>
              isActive ? 'sidebar-item-active' : 'sidebar-item'
            }
            key={index}
          >
            {item.icon}
            <span >{item.label}</span>
          </NavLink>
        ))}
        <hr className="sidebar-divider" />
        {routes.map((item, index) => (
          <NavLink
            to={changeLocation(`/viewer/${idProject}${item.href}`)}
            className={({ isActive }) =>
              isActive ? 'sidebar-item-active' : 'sidebar-item'
            }
            key={index}
          >
            {item.icon}
            <span >{item.label}</span>
          </NavLink>
        ))}
        <hr className="sidebar-divider" />
        {routesJitSystem.map((item, index) => (
          <NavLink
            to={changeLocation(`/viewer/${idProject}${item.href}`)}
            className={({ isActive }) =>
              isActive ? 'sidebar-item-active' : 'sidebar-item'
            }
            key={index}
          >
            {item.icon}
            <span >{item.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  )
}

export default Sidebar
